import produce from 'immer';
import * as API from '~/domain/api';
import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';

export type BannerTypesState = {
  byId: Map<number, API.BannerType>;
};

export type Update = {
  byId: Map<number, API.BannerType>;
};

const prefix = '@bannerTypes';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  UPDATE: `${prefix}/UPDATE`
});

export const initialState: BannerTypesState = {
  byId: new Map()
};

const clearReducer: Reducer<BannerTypesState, void> = state => {
  return produce(state, draft => {
    draft.byId = initialState.byId;
  });
};

const updateReducer: Reducer<BannerTypesState, Update> = (state, action) => {
  return produce(state, draft => {
    draft.byId = action.byId as Map<number, API.BannerType>;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  update: createCreator<Update>(Types.UPDATE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.UPDATE]: updateReducer
});
